import { z } from "zod";
import { AgentIdSchema, IsoDateTimeSchema, RelativePathSchema } from "./primitives.js";

export const EmptyPayloadSchema = z.object({}).strict();
export const OkDataSchema = z.object({ ok: z.literal(true) }).strict();
const _AgentIdPayloadSchema = z.object({ agentId: AgentIdSchema }).strict();

export const ToolModeSchema = z.enum(["allow", "ask", "deny"]);

export const FileContentSchema = z
  .object({
    filename: z.string().min(1),
    contentType: z.string().min(1),
    size: z.number().int().nonnegative(),
    content: z.string().optional(),
    encoding: z.enum(["utf8", "base64"]).optional(),
    objectKey: z.string().min(1).optional(),
  })
  .strict();

export const FileEntrySchema = z
  .object({
    path: RelativePathSchema,
    name: z.string().min(1),
    type: z.enum(["file", "directory"]),
    size: z.number().int().nonnegative().optional(),
    modifiedAt: IsoDateTimeSchema,
  })
  .strict();

export const UploadFileSchema = z
  .object({
    path: RelativePathSchema,
    content: z.string().min(1).optional(),
    encoding: z.enum(["utf8", "base64"]).optional(),
    objectKey: z.string().min(1).optional(),
  })
  .strict()
  .superRefine((value, ctx) => {
    const hasInlineContent = value.content !== undefined;
    const hasObjectKey = value.objectKey !== undefined;
    if (hasInlineContent === hasObjectKey) {
      ctx.addIssue({
        code: "custom",
        message: "upload file requires exactly one of content or objectKey",
      });
    }
    if (hasInlineContent && value.encoding === undefined) {
      ctx.addIssue({
        code: "custom",
        path: ["encoding"],
        message: "encoding is required for inline content",
      });
    }
    if (hasObjectKey && value.encoding !== undefined) {
      ctx.addIssue({
        code: "custom",
        path: ["encoding"],
        message: "encoding is only valid for inline content",
      });
    }
  });

export type ToolMode = z.infer<typeof ToolModeSchema>;
export type FileContent = z.infer<typeof FileContentSchema>;
